import request from 'src/api/utils';
import * as ROUTES from 'src/api/routes';
import { AiPromptContext } from 'src/queries/useAiPromptContexts';

export async function getPromptContexts(facilityId: AiPromptContext['facilityId']) {
    const result = await request({
        ...ROUTES.GET_PROMPT_CONTEXTS,
        params: { facilityId },
    });

    return result.data;
}

export async function getPromptContextById(promptContextId: string) {
    const result = await request({
        ...ROUTES.GET_PROMPT_CONTEXT_BY_ID,
        pathParams: { promptContextId },
    });

    return result.data;
}

export async function createPromptContext(promptContextData: Partial<AiPromptContext>) {
    return await request({
        ...ROUTES.CREATE_PROMPT_CONTEXT,
        data: { ...promptContextData },
    });
}

export async function updatePromptContext(promptContextId: string, promptContextData: Partial<AiPromptContext>) {
    return await request({
        ...ROUTES.UPDATE_PROMPT_CONTEXT,
        pathParams: { promptContextId },
        data: { ...promptContextData },
    });
}

export async function activatePromptContext(promptContextId: string) {
    return await request({
        ...ROUTES.ACTIVATE_PROMPT_CONTEXT,
        pathParams: { promptContextId },
    });
}

export async function deactivatePromptContext(promptContextId: string) {
    return await request({
        ...ROUTES.DEACTIVATE_PROMPT_CONTEXT,
        pathParams: { promptContextId },
    });
}
